import type React from 'react';
import { isClient } from '../../../../utils/utils';

export const getMobilePopoverHeight = (
    headerRef: React.RefObject<HTMLElement>,
    isMobile: boolean,
): number | undefined => {
    const headerHeight = headerRef?.current?.getBoundingClientRect().height;

    if (isMobile && isClient && headerHeight) {
        return window.innerHeight - headerHeight;
    }

    return undefined;
};
